import styled from "styled-components";
import { theme } from "styles/theme";

export const StyledCheckbox = styled.input<{ size?: number }>`
  width: ${(props) => props.size || 15}px;
  height: ${(props) => props.size || 15}px;
`;
